const ITEMS = ["Stock Brokers", "Depository Participants", "Research Analysts", "Investment Advisers", "Portfolio Managers", "Alternative Investment Funds"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((t, i) => (
      <span key={t} className="flex items-center">
        <span className={`px-8 sm:px-12 whitespace-nowrap ${i % 2 ? "font-serif-i text-ink/80" : "font-display font-extrabold tracking-tight text-ink"}`}>{t}</span>
        <svg viewBox="0 0 24 24" className="w-6 h-6 sm:w-8 sm:h-8 text-[var(--brass-deep)] shrink-0" fill="currentColor"><path d="M12 0l2.6 9.4L24 12l-9.4 2.6L12 24l-2.6-9.4L0 12l9.4-2.6z" /></svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="editorial-marquee" className="relative bg-paper-2 border-y border-ink/15 py-8 sm:py-10 overflow-hidden">
    <div className="flex w-max marquee-track text-4xl sm:text-6xl lg:text-7xl leading-none">
      <Row />
      <Row />
    </div>
  </section>
);
